import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['../signup/signup.component.css', './signin.component.css'],
})
export class SigninComponent implements OnInit {

  details: any;
  
  constructor(
    private fb: FormBuilder,
    private authServ: AuthService,
    private tstr: ToastrService,
    private r: Router,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}
  ngOnInit(): void {
    this.convergeSignIn();

    let user = JSON.parse(localStorage.getItem('user')!);
    let lastLogIn = localStorage.getItem('lastUpdated')!;
    if(user && (Math.abs(Date.now() - parseInt(lastLogIn)) < (1800000))){
      if (user.status == 'approved') {
        this.r.navigateByUrl('main/dashboard');
      } else {
        this.r.navigateByUrl('main/profile');
      }
    }
  }
  signInForm = this.fb.group({
    email: ['', [Validators.email, Validators.required]],
    password: ['', Validators.required],
  });
  hide = true;
  hide1 = true;
  eye() {
    this.hide = !this.hide;
  }
  signIn() {
    this.authServ.signIn(this.signInForm.value).subscribe((r: any) => {
      this.authServ.loader = false;
      localStorage.setItem('token', r.data.original.token);
      localStorage.setItem('user', JSON.stringify(r.user));
      localStorage.setItem('wallet', JSON.stringify(r.wallet));
      localStorage.setItem('commission', JSON.stringify(r.commission));
      localStorage.setItem('lastUpdated', Date.now().toString())
      this.tstr.success('Successfully Signed In');
      if (r.user.status == 'approved') {
        localStorage.setItem('cert','uploaded')
        this.r.navigateByUrl('main/dashboard');
      } else {
        this.r.navigateByUrl('main/profile');
      }
    });
  }

  convergeSignIn() {
    localStorage.clear()
    this.route.queryParams.subscribe((params) => {

      if (params['token']) {
        const token = params['token'];
        localStorage.setItem('genTkn', token);
        const formData = new FormData();
        formData.set('token', token);

        this.http.post<any>('https://processflow.hh-converge.com/exp/services/api/token.aspx', formData).subscribe((response) => {
          console.log(response);
          if (response.isValidToken) {
            this.details = jwtDecode(token);
            console.log(this.details);
            localStorage.setItem('staff', JSON.stringify(this.details));

            this.authServ.signIn({
              email: this.details.email,
              password: this.details.name,
            }).subscribe({
              next: (r: any) => {
                this.authServ.loader = false;
                localStorage.setItem('token', r.data.original.token);
                localStorage.setItem('user', JSON.stringify(r.user));
                localStorage.setItem('wallet', JSON.stringify(r.wallet));
                localStorage.setItem('commission', JSON.stringify(r.commission));
                localStorage.setItem('lastUpdated', Date.now().toString());
                this.tstr.success('Successfully Signed In');
                console.log('Login successful', r);
                if (r.user.status == 'approved') {
                  this.r.navigateByUrl('main/dashboard');
                } else {
                  this.r.navigateByUrl('main/profile');
                }
              },
              error: (error: any) => {
                console.error('Login failed', error);
                const payload = {
                  email: this.details.email,
                  password: this.details.name,
                  role: 'staff',
                };

                this.authServ.register(payload).subscribe((r) => {
                  console.log(r);
                  this.login();
                });
              }
            });
          }
        }); 
      };
    })
  }

  login() {
    localStorage.clear();
    this.authServ
      .signIn({
        email: this.details.email,
        password: this.details.name,
      })
      .subscribe((r: any) => {
        console.log(r);
        this.authServ.loader = false;
        sessionStorage.setItem('token', r.token);
        localStorage.setItem('user', JSON.stringify(r.user));
        localStorage.setItem('token', r.data.original.token);
        this.r.navigateByUrl('main/profile')
        this.updateStaffInfo()
      });
  }

  updateStaffInfo() {
    let formData = new FormData();
    formData.append('name', this.details.name);
    formData.append('address', "Adeogun Ajose street");
    formData.append('phone', "09087236781");

    this.authServ.updt(formData).subscribe((r: any) => {
      console.log(r);
      this.authServ.loader = false;
      localStorage.setItem('user', JSON.stringify(r.data));
    })
  }
}
